import axios from 'axios';
import { serviceAccountErrorCallback } from '../../callbacks';
import { ROLES, UPDATE_ROLE, CREATE_ROLE, DELETE_ROLE } from './constants';

export function getRoles() {
  return axios
    .get(ROLES, { withCredentials: false })
    .catch(serviceAccountErrorCallback);
}

export function updateRole(roleId, params) {
  return axios
    .put(UPDATE_ROLE(roleId), params)
    .catch(serviceAccountErrorCallback);
}

export function createRole(params) {
  return axios.post(CREATE_ROLE, params).catch(serviceAccountErrorCallback);
}

export function deleteRole(roleId) {
  return axios.delete(DELETE_ROLE(roleId)).catch(serviceAccountErrorCallback);
}
